import {FC, HTMLAttributes} from 'external/react'
import {omit} from 'external/lodash'

type LabeledValueProps = {
    className?: string
    label?: string
    value: string
}

const LabeledValue: FC<LabeledValueProps & Partial<HTMLAttributes<HTMLHeadingElement>>> = props => {
    const {className = 'mb-2', label, value} = props
    const attr = omit(props, ['className', 'label', 'value'])
    return (
        <h6 className={className} {...attr}>
            {label ? `${label}: ` : ' '}
            <span>{value}</span>
        </h6>
    )
}

export {LabeledValue as default}